import React from 'react';

import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';
import getProductsBySku from 'apps/products/utils/getProductsBySku';
import RelatedFopsContainer from 'apps/products/containers/RelatedFopsContainer';
import containerTypes from 'apps/analytics/utils/containerTypes';

import ExtSectionTypes from 'apps/externalProducts/ExtSectionTypes';
import ExternalProductsContainer from '[theme-lib]/apps/externalProducts/containers/ExternalProductsContainer';

// Part in {} COMES FROM BE and is formed and limited on BE
// [{Scribe Up to 8 Items | Criteo up to 3 Items} | 3xRMS(Netwave)]
export default function OfferDetailsTopBarSponsoredItems(props) {
  const { productsPage, shouldBeDisplayed } = props;

  const noAdsReceivedFromBE =
  !productsPage.topBarSponsoredItems ||
  !productsPage.topBarSponsoredItems.sections ||
  !productsPage.topBarSponsoredItems.sections[0];

  if (!shouldBeDisplayed || noAdsReceivedFromBE) return null;

  const sectionWithScribeAndCriteo = productsPage.topBarSponsoredItems.sections[0];

  const sectionWithScribeAndCriteoAndRMS = {
    ...sectionWithScribeAndCriteo,
    contentAfterFops: getRMSFops(),
  };

  return (
    <section className="offerDetails-fops">
      <div className="offerDetails-fops__items">
        <RelatedFopsContainer
          containerType={containerTypes.FEATURED}
          fopCollection={sectionWithScribeAndCriteoAndRMS}
          gtmPageType={gtmPageTypes.Offers}
          productsBySku={getProductsBySku(sectionWithScribeAndCriteoAndRMS)}
          skipAnalytics
        />
      </div>
    </section>
  );
}

function getRMSFops() {
  const slotsAmount = 3;
  const fops = [];

  for (let i = 0; i < slotsAmount; i++) {
    pushSlotToFopsArrayEnd(fops, i);
  }

  return fops;

  function pushSlotToFopsArrayEnd(fopsArray, index) {
    const name = `${ExtSectionTypes.OFFER_DETAILS_CAROUSEL}_${index}`;

    fopsArray.push(
      <li className="fops-item" key={name}>
        <ExternalProductsContainer
          defaultFopWidth={1}
          name={name}
          forceParentUpdate={() => this.forceUpdate()}
        />
      </li>
    );
  }
}
